import {useProductDetailsQuery} from "./useProductDetailsQuery";
import {WarrantiesModel} from "../models/view/warrantiesModel";

export const useWarrantiesQuery = () => {
    const {model: {warranties}} = useProductDetailsQuery();
    return {model: new WarrantiesModel(warranties)}
}